import {
  formatDateTime,
  formatResource,
  formatTime,
  getStatusColor,
} from '@/features/AuditLogs/utils/auditLogUtils'
import type { AuditLogs } from '@/generated/http-clients/v3ApiSchemas'
import { Box, Table, Text } from '@chakra-ui/react'

interface AuditLogRowProps {
  log: AuditLogs
  isSelected: boolean
  onClick: () => void
  showDate?: boolean // Whether to show full date or just time
}

export function AuditLogRow({
  log,
  isSelected,
  onClick,
  showDate = true,
}: Readonly<AuditLogRowProps>) {
  const statusColor = getStatusColor(log.status)
  const timestamp = showDate
    ? formatDateTime(log.timestamp)
    : formatTime(log.timestamp)

  return (
    <Table.Row
      onClick={onClick}
      cursor="pointer"
      bg={isSelected ? 'blue.100' : undefined}
      _hover={{ bg: isSelected ? 'blue.200' : 'gray.50' }}
      transition="background-color 0.15s"
      outline={isSelected ? '2px solid' : undefined}
      outlineColor={isSelected ? 'blue.400' : undefined}
      outlineOffset="-2px"
    >
      {/* Status indicator cell */}
      <Table.Cell width="4px" p={0}>
        <Box
          w="4px"
          h="100%"
          minH="40px"
          bg={statusColor}
          borderLeftRadius="sm"
        />
      </Table.Cell>
      <Table.Cell>
        <Text fontSize="xs" fontFamily="mono" whiteSpace="nowrap">
          {timestamp}
        </Text>
      </Table.Cell>
      <Table.Cell>
        <Text fontSize="sm" fontWeight="medium" lineClamp="1">
          {log.user || '-'}
        </Text>
      </Table.Cell>
      <Table.Cell>
        <Text fontSize="sm" lineClamp="1" title={formatResource(log.resource)}>
          {formatResource(log.resource)}
        </Text>
      </Table.Cell>
    </Table.Row>
  )
}
